import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { Card as InnerCard } from '@xing-com/card';
import { GridItem, GridContainer } from '@xing-com/grid';
import {
  scale150,
  space3XL,
  space4XL,
  spaceL,
  spaceS,
  spaceXXL,
  xdlColorBackgroundSecondary,
} from '@xing-com/tokens';

export const Container = styled(GridContainer)`
  margin: ${space4XL} auto;
`;

export const HeadGrid = styled(GridItem)`
  text-align: center;
`;

export const MainGrid = styled(GridItem)`
  display: flex;
  gap: ${scale150};
  justify-content: center;
  flex-wrap: wrap;
`;

export const FooterGrid = styled(GridItem)`
  text-align: center;
  margin-top: ${space3XL};
`;

export const Card = styled(InnerCard)`
  max-width: 506px;
  padding: ${spaceXXL};
  border: 0;
  background: ${xdlColorBackgroundSecondary};
  > div {
    align-items: center;
    text-align: center;
    gap: ${spaceL};
  }
`;

export const IconRightButton = styled(Button)`
  > div {
    display: flex;
    flex-direction: row-reverse;
    gap: ${spaceS};
  }
`;
